<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol sm="2" xs="12">
        <BaseInput
          :options="usernameInput.options"
          :data="usernameInput.data"
          :listener="usernameInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Xuất báo cáo'"
              class="btn-action-primary"
              @click="exportSubmit()">
              <i class="fa fa-download"></i>&nbsp;&nbsp;Xuất báo cáo
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>
              {{ $refs.mainTable.getTotalElementByPage + index }}
            </td>
          </template>
          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #userName="{item}">
            <td>
              <span style="font-weight: 550;" v-c-tooltip.hover="item.address">{{ item.userName }}</span>
            </td>
          </template>
          <template #fullName="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.fullName }}</span>
            </td>
          </template>
          <template #enabled="{item}">
            <td>
                <span v-if="item.enabled == 1" class="dot-custom dot-success">
                Hoạt động
              </span>
              <span v-else class="dot-custom dot-danger">
                Vô hiệu hóa
              </span>
            </td>
          </template>
          <template #position="{item}">
            <td class="td-roles">
              <CBadge
                color="light"
                class="mr-1"
              >{{ item.position }}
              </CBadge>
            </td>
          </template>
          <template #role="{item}">
            <td class="td-roles">
              <CBadge
                color="light"
                class="mr-1"
              >{{ item.role }}
              </CBadge>
            </td>
          </template>
          <template #systems="{item}">
            <td v-if="item.systems" class="td-roles">
              <CBadge
                v-for="system in item.systems.split(',')"
                :key="system"
                color="light"
                class="mr-1"
              >{{ system }}
              </CBadge>
            </td>
            <td class="td-roles" v-else>
              <CBadge color="infor" class="mr-1">Chưa gán</CBadge>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "UsersList",
  components: {
    BaseFormLoading,
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      usernameInput: {
        options: {
          placeholder: "Tên đăng nhập",
          label: 'Tên đăng nhập'
        },
        data: {
          name: "username",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT"},
            {key: "createDate", label: "Ngày tạo"},
            {key: "userName", label: "Tên đăng nhập"},
            {key: "fullName", label: "Họ tên"},
            {key: "phone", label: "SĐT"},
            {key: "email", label: "Email"},
            {key: "enabled", label: "Trạng thái"},
            {key: "position", label: "Chức vụ"},
            {key: "role", label: "Nhóm người dùng"},
            {key: "systems", label: "Hệ thống"},
          ],
          slots: ["index", "userName", "fullName", "enabled", "createDate", "position", "role", "systems"],
          pageSize: 15
        },
        dataSource: {
          url: "/report/page-user",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    exportSubmit() {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/exports/users",
        dataSubmit() {
          return {
            username: that.usernameInput.data.model
          }
        },
        isJsonContentType: false,
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({message: that.$helper.getStringError(response.data.data)});
          } else {
            that.$helper.fetchAndDownloadByURI(response.data.data.path, response.data.data.name);
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
